<template>
    <CouponCodeGrid v-editable="blok" :data="couponCodeData" />
</template>

<script setup lang="ts">
import CouponCodeGrid from '~/components/page-building/coupon-code/CouponCodeGrid.vue';
import CouponCodeGridType from '~/types/CouponCodeGridType';
import ImageType from '~/types/ImageType';
import ButtonType from '~/types/ButtonType';

const props = defineProps({
    blok: {
        type: Object,
        required: true,
    },
    nextBlock: {
        type: Object,
        required: false,
        default: null,
    },
});

const couponCodeData = computed<CouponCodeGridType>(() => {
    const gridItems = props.blok.coupon_code_items
        ? props.blok.coupon_code_items
              .filter((gridItem: any) => {
                  const today = new Date();
                  const start_time = new Date(gridItem.start_date);
                  const end_time = new Date(gridItem.end_date);

                  if (
                      today.setHours(0, 0, 0, 0) <
                          start_time.setHours(0, 0, 0, 0) ||
                      today.setHours(0, 0, 0, 0) > end_time.setHours(0, 0, 0, 0)
                  ) {
                      return false;
                  }
                  return true;
              })
              .map((gridItem: any, index: number) => {
                  const end_time = new Date(gridItem.end_date);
                  const month = String(end_time.getMonth() + 1).padStart(
                      2,
                      '0',
                  );
                  const day = String(end_time.getDate()).padStart(2, '0');
                  const year = end_time.getFullYear();
                  const end_date_formatted = `${month}/${day}/${year}`;
                  return {
                      image:
                          gridItem.image && gridItem.image.filename
                              ? ({
                                    title: gridItem.image.title,
                                    alt: gridItem.image.alt,
                                    src: gridItem.image.filename,
                                } as ImageType)
                              : null,
                      title: gridItem.title,
                      short_description: gridItem.short_description,
                      long_description: richTextToHtml(
                          gridItem.long_description,
                      ) as string,
                      code: gridItem.code,
                      reverseLayout: gridItem.reverse_layout,
                      button:
                          gridItem.button && gridItem.button.length > 0
                              ? ({
                                    label: gridItem.button[0].label,
                                    url: gridItem.button[0].link.cached_url,
                                    style: gridItem.button[0].style,
                                    vEditable: gridItem.button[0],
                                } as ButtonType)
                              : null,
                      end_date: end_date_formatted,
                      backgroundColor: gridItem.background_color,
                      nextBackgroundColor: props.blok.coupon_code_items[
                          index + 1
                      ]
                          ? props.blok.coupon_code_items[index + 1]
                                .background_color
                          : null,
                      bottomAngle: gridItem.bottom_angle,
                  };
              })
        : [];

    return {
        heading: props.blok.heading,
        items: gridItems,
    };
});
</script>
